module.exports = __webpack_public_path__ + "static/img/preview-02.f4efdc96.webp";